module.exports = "<div id=\"content-wrapper\">\n        <!-- <div style=\"margin-top:0px;margin-bottom:15px;\">\n            <a [routerLink]=\"['/']\" class=\"link\" [routerLinkActive]=\"['active-link']\" [routerLinkActiveOptions]=\"{exact: true}\">ICIMS</a> | \n            <a [routerLink]=\"['/docusign']\" class=\"link\" [routerLinkActive]=\"['active-link']\">DocuSign</a> | \n            <a [routerLink]=\"['/sterling']\" class=\"link\" [routerLinkActive]=\"['active-link']\">Sterling</a>\n        </div> -->\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main